export enum enumPlatformType {
  UNDEFINED = 0,
  DESKTOP = 100,
  MOBILE = 200,
}
